import * as React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { smoothScrollIntoView } from '@cian/valuation-utils-component';
import { useDeviceType } from '@cian/ui-kit';

import { toggleReportStatus } from '../../actions/report';
import { EReportStatus } from '../../constants/report';
import { getAuthor } from '../../selectors/author';
import { trackPreviewReportOpen, trackReportSend } from '../../containers/SendReportContainer/tracking';
import { toggleStickyFooterVisible } from '../../actions/page';
import { useGetPlatform } from '../useGetPlatform';

export function useOpenPreview() {
  const deviceType = useDeviceType();
  const { realtyUserId: userId } = useSelector(getAuthor);
  const dispatch = useDispatch();
  const platform = useGetPlatform();

  return React.useCallback(() => {
    trackReportSend();
    dispatch(toggleStickyFooterVisible(true));
    dispatch(toggleReportStatus(EReportStatus.Preview));

    /**
     * При переводе отчета в состояние предпросмотра пушим запись в историю
     * чтобы кнопка "Назад" в браузере возвращала к дефолтному состоянию
     * страницы отчета
     */
    window.history.pushState('', document.title, location.href);

    smoothScrollIntoView(document.body);
    trackPreviewReportOpen({ userId, deviceType, platform });
  }, [dispatch, userId, deviceType, platform]);
}
